/**
 * Client-side mirror of Core monetization gates (postbuy_block then run_monetization).
 * Must stay aligned with onlyback/app/services/graph_config_service.py evaluate_allow_offer.
 */

import { evaluateCondition } from './conditionEval'

function _isAbsentTransitionCondition(raw) {
  if (raw === undefined || raw === null) return true
  if (typeof raw === 'object' && !Array.isArray(raw) && Object.keys(raw).length === 0) {
    return true
  }
  return false
}

/** Same as evaluate_postbuy_monetization_block: absent → no block (false). */
export function evaluatePostbuyBlockRaw(transitions, params) {
  const tr = transitions && typeof transitions === 'object' ? transitions : {}
  const raw = tr.postbuy_block
  if (_isAbsentTransitionCondition(raw)) return false
  if (typeof raw === 'boolean') return raw
  return Boolean(evaluateCondition(raw, params || {}))
}

/** Same as missing run_monetization → allow_offer false. */
export function evaluateRunMonetizationRaw(transitions, params) {
  const tr = transitions && typeof transitions === 'object' ? transitions : {}
  const raw = tr.run_monetization
  if (_isAbsentTransitionCondition(raw)) return false
  if (typeof raw === 'boolean') return raw
  return Boolean(evaluateCondition(raw, params || {}))
}

/**
 * @param {Record<string, unknown>} transitions graph_transitions slice
 * @param {Record<string, unknown>} params flat params (same as condition preview)
 * @returns {{ postbuy_block: boolean, run_monetization: boolean, allow_offer_effective: boolean }}
 */
export function computeMonetizationGatePreview(transitions, params) {
  const postbuy_block = evaluatePostbuyBlockRaw(transitions, params)
  const run_monetization = evaluateRunMonetizationRaw(transitions, params)
  const allow_offer_effective = !postbuy_block && run_monetization
  return { postbuy_block, run_monetization, allow_offer_effective }
}
